import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  TextField,
  FormControl,
  Button,
  IconButton,
  InputAdornment,
  Typography,
} from "@mui/material";
// import logo from "~assets/Logo.svg";
import { HidePasswordIcon, ShowPasswordIcon } from "../../Icons/index";
import { useAuth } from "~contexts/Auth";

const LoginForm: React.FC = () => {
  const [loginState, setLoginState] = useState({
    user: "",
    password: "",
    errorControl: false,
    showPassword: false,
  });
  const userInputRef = useRef<HTMLInputElement | null>(null);
  const passwordInputRef = useRef<HTMLInputElement | null>(null);

  const { Login, loginError } = useAuth();

  async function handleLogin(e: React.SyntheticEvent) {
    e.preventDefault();
    if (loginState.user === "" || loginState.password === "") {
      setLoginState({ ...loginState, errorControl: true });
    }
    await Login({
      stream: loginState.user,
      password: loginState.password,
      brand: "farm",
    });
  }

  const handleLoginChange = (e: React.ChangeEvent<any>): void => {
    setLoginState({
      ...loginState,
      user: e.target.value,
    });
  };

  const handlePasswordChange = (e: React.ChangeEvent<any>): void => {
    setLoginState({
      ...loginState,
      password: e.target.value,
    });
  };

  const handleClickShowPassword = () => {
    setLoginState({ ...loginState, showPassword: !loginState.showPassword });
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  useEffect(() => {
    // Browsers may populate autofill after initial render without firing onChange.
    const syncAutofillValues = () => {
      const autofilledUser = userInputRef.current?.value || "";
      const autofilledPassword = passwordInputRef.current?.value || "";

      if (autofilledUser || autofilledPassword) {
        setLoginState((prev) => ({
          ...prev,
          user: autofilledUser || prev.user,
          password: autofilledPassword || prev.password,
        }));
      }
    };

    const timerId = window.setTimeout(syncAutofillValues, 120);
    return () => window.clearTimeout(timerId);
  }, []);

  return (
    <>
      <Grid>
        <Typography variant="h2">AZZASLIVE</Typography>
      </Grid>
      <Grid item display="flex" flexDirection="column">
        <form onSubmit={handleLogin}>
          <FormControl>
            <TextField
              error={loginState.errorControl || loginError}
              helperText={
                loginState.errorControl === true || loginError
                  ? "verifique se seu login está correto"
                  : null
              }
              onChange={handleLoginChange}
              value={loginState.user}
              label="login"
              variant="outlined"
              sx={{ mt: 1.6, width: 365 }}
              autoComplete="username"
              inputRef={userInputRef}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              error={loginState.errorControl || loginError}
              helperText={
                loginState.errorControl === true || loginError
                  ? "verifique se sua senha está correta"
                  : null
              }
              onChange={handlePasswordChange}
              value={loginState.password}
              label="senha"
              variant="outlined"
              sx={{ mt: 1.5, mb: 0.5, width: 365 }}
              type={loginState.showPassword ? "text" : "password"}
              autoComplete="current-password"
              inputRef={passwordInputRef}
              InputLabelProps={{ shrink: true }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                      disableRipple
                      sx={{ marginRight: 0.5, color: "transparent" }}
                    >
                      {loginState.showPassword ? (
                        <ShowPasswordIcon />
                      ) : (
                        <HidePasswordIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Button
              variant="contained"
              sx={{
                mt: 2,
                width: "365px",
                height: "56px",
              }}
              type="submit"
            >
              entrar
            </Button>
          </FormControl>
        </form>
      </Grid>
    </>
  );
};

export default LoginForm;
